module.exports = __webpack_public_path__ + "static/img/美的无冷感燃气热水器S9.6ee310d5.png";